import styled from "styled-components";

export const FeatureWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: #fff;
  padding: 80px 0;
`;

export const FeatureContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 1200px;
  width: 95%;
  gap: 40px;
`;
export const FeatureCards = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  width: 100%;
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (max-width: 540px) {
    grid-template-columns: 1fr;
  }
`;
export const Card = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  border-radius: 8px;
  border: 1px solid rgba(225, 29, 72, 0.4);
  padding: 16px 0 16px 16px;
  position: relative;
  cursor: pointer;
  height: 80px;
  @media screen and (max-width: 540px) {
    align-items: center;
  }
  &::before {
    content: "";
    position: absolute;
    width: calc(100% + 4px);
    height: calc(100% + 4px);
    top: calc(2px / -1);
    left: calc(2px / -1);
    background: linear-gradient(to right, #e11d48 0%, #e11d48 100%),
      linear-gradient(to top, #e11d48 50%, transparent 50%),
      linear-gradient(to top, #e11d48 50%, transparent 50%),
      linear-gradient(to right, #e11d48 0%, #e11d48 100%),
      linear-gradient(to left, #e11d48 0%, #e11d48 100%);
    background-size: 100% 2px, 2px 200%, 2px 200%, 0% 2px, 0% 2px;
    background-position: 50% 100%, 0% 0%, 100% 0%, 100% 0%, 0% 0%;
    background-repeat: no-repeat, no-repeat;
    transition: transform 0.4s ease-in-out, background-position 0.4s ease-in-out,
      background-size 0.4s ease-in-out;
    transform: scaleX(0) rotate(0deg);
    transition-delay: 0.7s, 0.4s, 0s;
  }
  &:hover {
    &::before {
      background-size: 200% 2px, 2px 400%, 2px 400%, 55% 2px, 55% 2px;
      background-position: 50% 100%, 0% 100%, 100% 100%, 100% 0%, 0% 0%;
      transform: scaleX(1) rotate(0deg);
      transition-delay: 0s, 0.4s, 0.7s;
    }
    svg {
      transition: all .3s;
      color: #e11d48;
    }
  }
`;
export const CardHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  svg {
    font-size: 24px;
  }
  h4 {
    font-size: 18px;
    font-weight: 500;
  }
`;
export const CardContent = styled.div`
  span {
    font-size: 14px;
    line-height: 24px;
    @media screen and (max-width: 540px) {
      text-align: center;
    }
  }
`;
